'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _dom = require('../common/dom.js');

var _dom2 = _interopRequireDefault(_dom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var init = exports.init = function init() {
  bindUIActions();
};

var dropdownState = function dropdownState(state) {
  if (state == 'active') {
    (0, _jquery2.default)(_dom2.default.sizeDropdown).addClass('is-active');
    (0, _jquery2.default)(_dom2.default.sizeDropdownTrigger).addClass('is-active');
  } else {
    (0, _jquery2.default)(_dom2.default.sizeDropdown).removeClass('is-active');
    (0, _jquery2.default)(_dom2.default.sizeDropdownTrigger).removeClass('is-active');
  }
};

var featureImageUpdate = function featureImageUpdate(image) {
  (0, _jquery2.default)(_dom2.default.frameFeatureImage).find('img').attr('srcset', image);
  (0, _jquery2.default)(_dom2.default.frameFeatureImage).find('img').attr('src', image);
  (0, _jquery2.default)(_dom2.default.frameFeatureImage).find('source').attr('srcset', image);
};

var bindUIActions = function bindUIActions() {
  (0, _jquery2.default)(document).on('click', _dom2.default.sizeDropdownTrigger, function () {
    if (!(0, _jquery2.default)(this).hasClass('is-active')) {
      dropdownState('active');
    } else {
      dropdownState('inactive');
    }
  });

  (0, _jquery2.default)(document).on('click', _dom2.default.optionTrigger, function () {
    var value = _jquery2.default.trim((0, _jquery2.default)(this).text());
    (0, _jquery2.default)(_dom2.default.productMeta).text((0, _jquery2.default)(_dom2.default.productVariant + ' option[value="' + (0, _jquery2.default)(_dom2.default.productVariant).val() + '"]').attr('data-variant-title'));

    if ((0, _jquery2.default)(this).attr('data-option-image') != undefined) {
      var image = (0, _jquery2.default)(this).attr('data-option-image');
      featureImageUpdate(image);
    }

    if ((0, _jquery2.default)(this).parent(_dom2.default.sizeDropdown).length > 0) {
      (0, _jquery2.default)(_dom2.default.sizeDropdownTrigger).find('[data-size-trigger-text]').text(value);
      (0, _jquery2.default)(_dom2.default.sizeDropdown).find(_dom2.default.optionTrigger).removeClass('is-active');
      (0, _jquery2.default)(this).addClass('is-active');
      dropdownState('inactive');
    } else {
      (0, _jquery2.default)(_dom2.default.optionTrigger).removeClass('selected');
      (0, _jquery2.default)(this).addClass('selected');
    }

    (0, _jquery2.default)('.single-option-selector option[value="' + value + '"').prop('selected', true).trigger('change');
  });
};